// extracted by mini-css-extract-plugin
export default {"title":"FastenersGroup-module__title--a7_fa"};